import { render } from "./App.vue?vue&type=template&id=3d3593d4"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=3d3593d4&lang=css"

import exportComponent from "C:\\Users\\houbkar\\WebstormProjects\\PO\\2022-PO-LMO-HTML\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__